import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnChanges, ElementRef, ViewChild } from "@angular/core";
import { BoxOpenModeService } from "../../../services/boxOpenMode/boxOpenMode.service";

@Component({
    selector: "mobileSelect",
    template: require('./mobileselect.component.html'),
    styles: [require('./mobileselect.component.scss')]
})
export class mobileSelectComponent implements OnInit, AfterViewInit, OnChanges {


    
    @ViewChild("#menuContainer")
    menuContainer?: ElementRef;





    @Input() public list: any[] = [];

    @Input() public set inputValue(value: any) {
        //  this._categoryId = value;
        //  this.doSomething(this._categoryId);
        this.currentValue = value;

        if (this.list !== undefined) {
            let i = this.list.filter(v => {
                if (v.id == value) {
                    return v;
                }
            });

            if (i[0] !== undefined) {
                if (i[0].image !== undefined) {
                    this.image = i[0].image;
                }
            }
        }
    }

    @Input() public cid: any;
    @Input() public topposition: any;
    @Input() public leftposition?: any = 0;
    @Input() public maxheight: any;
    @Input() public showsearch: boolean = false;
    @Input() public isbtn: boolean = false;
    @Input() public isicon: boolean = false;
    @Input() public showbaskets:boolean = false;




    @Output("update")
    change: EventEmitter<number> = new EventEmitter<number>();

    @Output("outlistAction")
    outlist: EventEmitter<boolean> = new EventEmitter<boolean>();

    increment() {
        this.change.emit(this.currentValue);
    }

    private _currentValue: any;
    public get currentValue(): any {
        return this._currentValue;
    }
    public set currentValue(v: any) {
        this._currentValue = v;
    }

    constructor(private openModeService: BoxOpenModeService) {
        this.openModeService.mobileControlsOpen.subscribe(activeControl => {
            if (activeControl !== this.cid) {
                this.isOpened = false;
            }
        });
    }

    private _previousLabel: string = "..";
    public get previousLabel(): string {
        return this._previousLabel;
    }
    public set previousLabel(value: string) {
        this._previousLabel = value;
    }

    get currentLabel() {
        let v = this.list.filter(v => {
            if (v.id == this.currentValue) {
                return v;
            }
        });
        if (v[0] !== undefined) {
            this.previousLabel = v[0].label;
            return v[0].label;
        } else {
            this.outlist.emit(true);
            return this.previousLabel;
        }
    }

    ngAfterViewInit() {
        //  this.currentValue=this.inputValue;
    }

    ngOnInit() {
        //  this.currentValue=this.inputValue;
    }

    private _isOpened: boolean = false;
    public get isOpened(): boolean {
        return this._isOpened;
    }
    public set isOpened(value: boolean) {
        if (value) {
            this.openModeService.mobileControlsOpen.next(this.cid);
        }

        this._isOpened = value;
    }

    setOpenChange() {
        this.isOpened = !this.isOpened;
    }

    private _image: any;
    public get image(): any {
        return this._image;
    }
    public set image(value: any) {
        this._image = value;
    }

    public emitValue(val: any, image?: any) {
        this.currentValue = val;
        this.isOpened = false;

        if (image !== undefined) {
            this.image = image;
        }

        this.increment();
    }

    get screnWidth() {
        return screen.availWidth - 10;
        //return window.innerWidth - 10;
    }

    ngOnChanges() {
        // create header using child_id
        //  console.log(this.list);
    }

    private _searchValue: string = "";
    public get searchValue(): string {
        return this._searchValue;
    }
    public set searchValue(value: string) {
        this._searchValue = value;
    }

    public filterContains(item: string) {
        item = item.toLocaleLowerCase();

        if (item.includes(this.searchValue.toLocaleLowerCase()) || this.searchValue == "") {
            return true;
        }

        return false;
    }

    public get maxHeightHD()
    {
        let topLocation:number = 0;
        if(this.menuContainer)
        {
            topLocation =  this.menuContainer.nativeElement.offsetLeft;
        }
     



        return screen.availHeight - topLocation;
    }
}
